<template>
    <div class="w-full flex flex-wrap justify-center p-5">
        <div class="mb-5">
            <v-alert type="error" outlined dense v-if="user.vehicles.length === 0 ">You have not registered a vehicle.  The parking hang tag is not valid and will not be distributed until a vehicle is registered.  Please do so now.</v-alert>
            <v-alert type="info" outlined dense >This Hang Tag permit receipt, and a photo ID (university i-card, drivers license, etc.), must be presented to the Parking Operations Office, in order to receive the appropriate Hang Tag.</v-alert>

        </div>

        <v-card class="w-full" raised>
            <v-card-title>
                <span>Parking Permit Receipt for {{ receipt.customer_name }}</span>
                <v-spacer></v-spacer>
            </v-card-title>
            <v-card-subtitle>Permit Number - {{ receipt.permit_number.substr(1,10) }}</v-card-subtitle>
            <v-divider></v-divider>
            <v-card-text>
                <div class="p-2">
                    <div class="flex flex-wrap justify-start content-center -mx-4">
                        <div class="w-full md:w-1/3 px-2">
                            <v-text-field disabled v-model="receipt.customer_name" label="Customer Name"></v-text-field>
                        </div>
                        <div class="w-full md:w-1/3 px-2">
                            <v-text-field disabled v-model="receipt.provided_phone" label="Contact Number"></v-text-field>
                        </div>
                        <div class="w-full md:w-1/3 px-2">
                            <v-text-field disabled v-model="receipt.employee_or_student === 'E' ? 'Employee' : 'Student'" label="Employee/Student"></v-text-field>
                        </div>
                    </div>
                </div>
                <v-divider></v-divider>
                <v-divider></v-divider>
                <div class="px-2">
                    <div class="flex flex-wrap justify-start content-center items-center -mx-4">
                        <div class="w-full md:w-1/2 px-2">
                            <v-card>
                                <v-card-title>Permit Information</v-card-title>
                                <v-card-subtitle>{{ receipt.description }}</v-card-subtitle>
                                <v-divider></v-divider>
                                <v-card-text>
                                    <div class="px-2">
                                        <div class="flex flex-wrap justify-start content-center items-center -mx-4">
                                            <div class="w-full md:w-full px-2">
                                                <v-text-field disabled v-model="receipt.permit_number.substr(1,10)" prepend-icon="palette" label="Permit Number"></v-text-field>
                                            </div>
                                            <div class="w-full md:w-full px-2">
                                                <v-text-field disabled v-model="receipt.permit_number_series_code" prepend-icon="palette" label="Permit Series Code"></v-text-field>
                                            </div>
                                            <div class="w-full md:w-full px-2">
                                                <v-text-field disabled v-model="receipt.permit_year" prepend-icon="palette" label="Permit Year"></v-text-field>
                                            </div>
                                            <div class="w-full md:w-full px-2">
                                                <v-text-field disabled v-model="receipt.permit_number_status_desc" prepend-icon="palette" label="Permit Status"></v-text-field>
                                            </div>
                                        </div>
                                    </div>
                                </v-card-text>
                            </v-card>
                        </div>
                        <div class="w-full md:w-1/2 px-2">
                            <v-card>
                                <v-card-title>Transaction Information</v-card-title>
                                <v-divider></v-divider>
                                <v-card-text>
                                    <div class="px-2">
                                        <div class="flex flex-wrap justify-start content-center items-center -mx-4">
                                            <div class="w-full md:w-full px-2">
                                                <v-text-field disabled v-model="receipt.payment_type" prepend-icon="palette" label="Payment Type"></v-text-field>
                                            </div>
                                            <div class="w-full md:w-full px-2">
                                                <v-text-field disabled v-model="receipt.transactionid" prepend-icon="palette" label="Transaction Number"></v-text-field>
                                            </div>
                                            <div class="w-full md:w-full px-2">
                                                <v-text-field disabled v-model="receipt.referenceid" prepend-icon="palette" label="Reference ID"></v-text-field>
                                            </div>
                                            <div class="w-full md:w-full px-2">
                                                <v-text-field disabled v-model="receipt.p1_permit_fee" prepend-icon="palette" label="Amount"></v-text-field>
                                            </div>
                                        </div>
                                    </div>
                                </v-card-text>
                            </v-card>
                        </div>
                    </div>
                </div>
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
    export default {
        data() {
            return {

            }
        },
        props: {
            user: {
                required: true,
                type: Object
            },
            receipt: {
                required: true,
                type: Object
            }
        },
        created() {
            console.log(this.receipt);
        },
        methods: {

        }
    }
</script>
